import script from "./ProductCoverDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCoverDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCoverDetails.vue?vue&type=style&index=0&id=5023ecdf&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5023ecdf"]])

export default __exports__